import React, { useEffect, useState } from 'react';
import styles from './ATSCases.module.scss'
import { Pagination, Table } from 'react-bootstrap';
import axios from '../../../axios';
import { Button } from 'antd';

type ATSCase = {
    idCase: number;
    level: AtsCaseLevel;
    path: string;
    noteType: AtsCaseNoteType;
}

enum AtsCaseLevel
{
    Site = 1,
    Turbine = 2,
}

enum AtsCaseNoteType
{
    HighPriority,
    AnnotationComplete,
    CriticalFindingsOnAssessment,
    InspectionClosed
}

const ATSCases: React.FC = () => {
    const [cases, setCases] = useState<ATSCase[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [innerLoading, setInnerLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [page, setPage] = useState(1)
    const [caseId, setCaseId] = useState<string>('');
    const [path, setPath] = useState<string>('');
    const [searchFlag, setSearchFlag] = useState<boolean>(true);
    const [totalCasesCount, setTotalCasesCount] = useState<number>(0);

    useEffect(() => {
        if(!searchFlag) return;

        const fetchData = async () => {
            try {
                setInnerLoading(true);
                const response = await axios.get<ATSCase[]>(`info/atscases?page=${page}&caseId=${caseId}&path=${path}`);
                setCases(response.data);
            } catch (err) {
                setError('Error fetching data');
            } finally {
                setLoading(false);
                setInnerLoading(false);
            }
        };

        setSearchFlag(false);
        fetchData();
    }, [caseId, page, path, searchFlag]);

    useEffect(() => {
        const fetchData = async () => {
            try {
              setInnerLoading(true);
                const response = await axios.get<number>(`info/atscases/total`);
                setTotalCasesCount(response.data);
            } catch (err) {
                setError('Error fetching data');
            } finally {
                setInnerLoading(false);
            }
        };

        fetchData();
    }, []);

    if (loading) {
        return <div style={{height: '100vh', width: '100vw', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>Loading...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    let casesList = cases.map(x => {
        return (
          <tr key={x.idCase} className={styles.statusRow}>
            <td className={styles.value}>
              <span>{x.idCase}</span>
            </td>
            <td className={styles.value}>
              <span>{x.path}</span>
            </td>
            <td className={styles.value}>
                <span>{AtsCaseLevel[x.level]}</span>
            </td>
            <td className={styles.value}>
                <span>{AtsCaseNoteType[x.noteType]}</span>
            </td>
          </tr>
        );
      });

    return (
        <div className={styles.atsContainer}>
          <div className={styles.description}>
            <span>Total number of created ATS cases: <b>{totalCasesCount}</b>. Here you can see first 20 results for any filter...</span>
          </div>
            <div>
                <div className={styles.searchContainer}>
                    <input
                        type="text"
                        placeholder="Search by Case Id"
                        value={caseId}
                        onChange={(e) => {
                            setCaseId(e.target.value);
                        }}
                    />
                    <input
                        type="text"
                        placeholder="Search by Path"
                        value={path}
                        onChange={(e) => {
                            setPath(e.target.value);
                        }}
                    />
                    <Button loading={innerLoading} title='Search' type='primary' onClick={() => setSearchFlag(true)}>Search</Button>
                    <Button loading={innerLoading} title='Clear' type='primary' onClick={() => {setPath(''); setCaseId(''); setSearchFlag(true)}}>Clear</Button>
                </div>
            </div>
            <Table striped bordered hover className={styles.atsTable}>
        <thead>
          <tr>
            <th>Case Id</th>
            <th>Path</th>
            <th>Level</th>
            <th>Initial Case Condition</th>
          </tr>
        </thead>
        <tbody>
          {cases.length > 0 ? (
            casesList
          ) : (
            <tr>
              <td colSpan={4}>There is no data.</td>
            </tr>
          )}
        </tbody>
      </Table>
        </div>
    );
};

export default ATSCases;